angular.module('app').config(debitNotesRouting);

function debitNotesRouting($routeProvider) {
  $routeProvider
    .when('/debit_notes', {
      pageTitle: 'DEBIT_NOTES',
      template: '<debit-notes-page></debit-notes-page>',
      menu: 'sales',
      accessPermission: 'index_debitnote_accountadmin',
      authReq: true,
    })
    .when('/debit_notes/new', {
      params: {
        invoiceId: null,
        creditNoteId: null,
        invoiceNumber: null,
        creditNoteNumber: null,
        clientId: null,
      },
      pageTitle: 'ADD_DEBIT_NOTE',
      template: '<debit-note-page></debit-note-page>',
      breadcrumb: {
        label: 'DEBIT_NOTES',
        parent: 'debit_notes',
        ajs: true,
      },
      menu: 'sales',
      accessPermission: 'create_debitnote_accountadmin',
      authReq: true,
    })
    .when('/debit_notes/:id', {
      params: {
        mode: null,
      },
      pageTitle: 'DEBIT_NOTE',
      template: '<debit-note-page></debit-note-page>',
      breadcrumb: {
        label: 'DEBIT_NOTES',
        parent: 'debit_notes',
        ajs: true,
      },
      menu: 'sales',
      accessPermission: 'show_debitnote_accountadmin',
      authReq: true,
    });
}

debitNotesRouting.$inject = ['$routeProvider'];
